import { createReducer } from '@reduxjs/toolkit';
import { authenticateRejected, setUnverifiedUser, fetchImpacterTermsOfUseUpdated } from './actions';
import { clearUser, fetchImpacterProfile, fetchUser, setUnverifiedUserId } from './index';
import initialState from './initialState';
import { isUnverifiedUser } from './typeGuards';

export const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(authenticateRejected, (state) => {
      state.user = {
        data: { isUnauthenticated: true },
        error: { authenticationError: true },
      };
    })
    .addCase(setUnverifiedUser, (state, { payload }) => {
      const { email, name } = payload;
      state.user = {
        data: {
          isUnverified: true,
          email,
          name,
        },
      };
    })
    .addCase(setUnverifiedUserId, (state, { payload }) => {
      if (isUnverifiedUser(state.user.data)) {
        state.user.data.id = payload.id;
      }
    })
    .addCase(fetchUser.fulfilled, (state, action) => {
      state.user = {
        data: action.payload,
      };
    })
    .addCase(fetchUser.rejected, (state, { payload, error }) => {
      state.user = {
        data: { isUnauthenticated: true },
        error: payload?.authenticationError ? payload : error,
      };
    })
    .addCase(clearUser, (state) => {
      state.user = {
        data: {
          isUnauthenticated: true,
        },
      };
      state.impacter = {
        fetching: false,
        data: null,
      };
    })
    .addCase(fetchImpacterProfile.pending, (state) => {
      state.impacter = {
        fetching: true,
        data: null,
      };
    })
    .addCase(fetchImpacterProfile.fulfilled, (state, action) => {
      state.impacter = {
        fetching: false,
        data: action.payload,
      };
    })
    .addCase(fetchImpacterProfile.rejected, (state, action) => {
      state.impacter = {
        fetching: false,
        data: null,
        error: action.error,
      };
    })
    .addCase(fetchImpacterTermsOfUseUpdated.fulfilled, (state, { payload }) => {
      state.impacterTerms = {
        slug: payload?.slug,
        updated: payload?.updated,
      };
    });
});
